import React from 'react'
import { Link } from 'react-router-dom'
import CardUI from '../../../widgets/layout/CardUI'
import SwitchUI from '../../../widgets/action/SwitchUI.js'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import SuperUserHomePageUI from '../../../templates/SuperUserHomePageUI.js'
import GenericErrorUI from '../../../components/common/GenericErrorUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import EmptyListUI from '../../../widgets/output/EmptyListUI'
import SpinnerUI from '../../../widgets/output/SpinnerUI'
import './PenaltyReportPage.css'

const PenaltyReportPageUI = ({ context, errorList, penalties, penaltyList, penalChargeFilteredList,
  totalDefaultInterest, month, year, onRefreshClick, onDownloadClick, downloadSubmitted,
  onSendInternalEmail, showAccWithPenalCharge, onShowAccWithPenalChargeClick
}) =>
  <SuperUserHomePageUI context={context} className='pg_su_pr_lst' topnav='accounts' dimension='w1600'
    headerText='Penalty tracker' centered={!penaltyList && !errorList} page='penalty'
  >
    {
      !penaltyList && !errorList &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    <div>
      {
        penaltyList &&
        <>
          <LRTableActionsUI location='top'
            left={
              <span className='g_flex_left g_flex_h'>
                <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
                <IconButtonUI icon='icon-download' onClick={onDownloadClick} label='Download' />
                <SpinnerUI className='g_m_left_25' reserveSpace={true} show={downloadSubmitted} />
                <span className='g_m_left_100 g_large'><b>Penalty Tracker{month && ','} {penalties.penaltyMonthYear}</b></span>
              </span>
            }
            right={
              <span>
                <Link to='#' onClick={onSendInternalEmail} >Internal email</Link>
                <span className='g_m_left_100' />
                <Link to={`/su/penalty/${penalties.month == 1 ? penalties.year - 1 : penalties.year}/${penalties.month == 1 ? 12 : penalties.month - 1}`}>Previous</Link>
                <span className='g_m_left_100' />
                <Link to={`/su/penalty/${penalties.month == 12 ? penalties.year + 1 : penalties.year}/${penalties.month == 12 ? 1 : penalties.month + 1}`}>Next</Link>
              </span>
            }
          />
        </>
      }
      {
        penaltyList && penaltyList.length !== 0 &&
        <PenaltyReportUI
          context={context}
          onRefreshClick={onRefreshClick}
          penaltyList={showAccWithPenalCharge ? penalChargeFilteredList : penaltyList}
          showAccWithPenalCharge={showAccWithPenalCharge}
          onShowAccWithPenalChargeClick={onShowAccWithPenalChargeClick}
          totalDefaultInterest={totalDefaultInterest}
        />
      }
      {
        penaltyList && penaltyList.length === 0 &&
        <div className='g_m_top_200'>
          <EmptyListUI
            context={context}
            createEnabled={false}
            createDisabledMessageLabel='No penalties'
          />
        </div>
      }
    </div>
  </SuperUserHomePageUI>

const PenaltyReportUI = ({ penaltyList, totalDefaultInterest, showAccWithPenalCharge, onShowAccWithPenalChargeClick
}) =>
  <CardUI className='scard' noUnderline={true}
    title={
      <span className='g_flex_h g_flex_right'>
        <span className='g_muted g_m_right_50'>
          Show accounts with penal charge
        </span>
        <SwitchUI
          checked={showAccWithPenalCharge}
          onChange={onShowAccWithPenalChargeClick}
        />
      </span>
    }
  >
    <table className='table_pr table'>
      <thead className='g_sticky'>
        <tr>
          <th className='column'>Account</th>
          <th className='column'>Penal Charge</th>
          <th className='column'>Compliance Remarks</th>
          <th className='column'>Monitoring Remarks</th>
        </tr>
      </thead>
      <tbody>
        {
          penaltyList.map((account, i) =>
            <tr key={i}>
              <td className='g_text_left column g_no_wrap_2'>
                <span className={account.defaultInterestFormulaList.length > 0 ? 'g_error' :
                  account.monitoringRemarksList && account.monitoringRemarksList.length > 0 ? 'g_info' : 'g_success'}>
                  {i + 1} {account.accountName}
                </span>
              </td>
              <td className='column'>
                {
                  account.defaultInterestF5 &&
                  <span className='g_flex_v'>
                    {account.defaultInterestF5}
                    {
                      account.defaultInterestFormulaList.map((f, i) =>
                        <span key={i} className='g_small g_muted'>{f}</span>
                      )
                    }
                  </span>
                }
              </td>
              <td className='g_text_left column'>
                {
                  account.csRemarksList && account.csRemarksList.map((remarks, j) =>
                    <span key={j} className='g_flex_h g_flex_left g_flex_top g_small'>
                      <span>{j + 1}.</span>
                      <span className='g_m_left_25'>
                        <Link to={`/su/loans/${remarks.loanId}/compliance/cs`}>{remarks.remarksDateF}</Link> <b>{remarks.objectId}: {remarks.status}:</b> {remarks.remarks}
                      </span>
                    </span>
                  )
                }
              </td>
              <td className='g_text_left column'>
                {
                  account.monitoringRemarksList && account.monitoringRemarksList.map((remarks, j) =>
                    <span key={j} className='g_flex_h g_flex_left g_flex_top g_small'>
                      <span>{j + 1}.</span>
                      <span className='g_m_left_25'>
                        <Link to={`/su/loans/${remarks.loanId}/monitoring`}>{remarks.remarksDateF}</Link> {remarks.remarks}
                      </span>
                    </span>
                  )
                }
              </td>
            </tr>
          )
        }
      </tbody>
      <thead>
        <tr>
          <th className='column'>Total</th>
          <th className='column'>{totalDefaultInterest}</th>
          <th className='column'></th>
          <th className='column'></th>
        </tr>
      </thead>
    </table>
  </CardUI>

export default PenaltyReportPageUI
